import { AnalyticsEvent } from '../models';

export class CheckoutEvent implements AnalyticsEvent {
  name = 'CheckoutEvent';
  constructor(public readonly eventType?: string) {}
}
